// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import {
  applyAspectRatioBoxInsideStyles,
  applyAspectRatioBoxStyles,
} from '@tcp/core/src/utils/utils.web';

const stylesGridPromo = css`
  &.promo-div {
    height: 100%;
    text-align: center;
    background: url(https://test1.theplace.com/image/upload${props => props.promoObj && props.promoObj.mediaWrapper && props.promoObj.mediaWrapper[0] && props.promoObj.mediaWrapper[0].url});
    display: flex;
    flex-direction: column;
    justify-content: center;

    .highlighted-text {
      background: linear-gradient(to top, yellow 70%, transparent 70%);
      padding: 0 15px;
    }
    .headline-wrapper {
      padding-bottom: 12px;
    }
    .middle-text-wrapper {
      padding-bottom: 30px;
    }

    .description-wrapper {
      padding-bottom: 24px;
    }
  }
`;
export default stylesGridPromo;

export const StyledModuleWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'MOBILE')}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
`;

export const StyledModule = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'MOBILE')}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
`;
